import React from "react";
import gambar1 from "./image/gambar1.png";
import gambar2 from "./image/gambar2.jpg";
import uniski from "./image/uniski-top.jpg";
import rka from "./image/anggaran.png";
import aset from "./image/asset.jpg";
import realisasi from "./image/realisasi.png";
import { Link } from "react-router-dom";

function Dash () {
    return(
        <>
            <div className="container-fluid my-5">
                <div className="row g-3">
                    <div className="col-md-12 row g-0 position-relative">
                        <div className="col-md-12" style={{backgroundImage: `url(${uniski})`, height: "400px", backgroundSize: "cover", backgroundPosition: "center", filter: "blur(2px)"}}>
                        </div>
                        <div className="col-md-6 text-center position-absolute top-50 start-50 border rounded border-3 bg-dark bg-opacity-50 translate-middle p-2">
                            <h3 className="text-white">Sistem Informasi dan Inventaris Digital</h3>
                            <h5 className="text-white">Universitas Islam Ogan Komering Ilir Kayuagung</h5>
                            <Link className="btn btn-success" to="/login">Masuk Untuk Memulai <i class="bi bi-box-arrow-in-left text-white" /></Link>
                        </div>
                    </div>
                    <div className="col-md-12 row g-0 text-center">
                        <div className="col-md-4 p-5 row g-0">
                            <div className="col-md-12 row g-0 rounded border border-2 rounded shadow-lg align-items-center" >
                                <div className="col-md-6">
                                    <img src={rka} className="img-fluid" height="200" width="200" style={{objectFit: "cover"}}></img>
                                </div>
                                <div className="col-md-6 rounded" style={{height: "200px", backgroundColor: "#188ea6"}}>
                                    <p className="fs-5 fw-bolder font-monospace text-light">Rencana Kerja dan Anggaran</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 p-5 row g-0">
                            <div className="col-md-12 row g-0 rounded border border-2 rounded shadow-lg align-items-center" >
                                <div className="col-md-6">
                                    <img src={realisasi} className="img-fluid" height="200" width="200" style={{objectFit: "cover"}}></img>
                                </div>
                                <div className="col-md-6 rounded" style={{height: "200px", backgroundColor: "#f2b65b"}}>
                                    <p className="fs-5 fw-bolder font-monospace text-light">Usulan Pembiayaan</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 p-5 row g-0">
                            <div className="col-md-12 row g-0 rounded border border-2 rounded shadow-lg align-items-center" >
                                <div className="col-md-6">
                                    <img src={aset} className="img-fluid" height="200" width="200" style={{objectFit: "cover"}}></img>
                                </div>
                                <div className="col-md-6 rounded" style={{height: "200px", backgroundColor: "#188ea6"}}>
                                    <p className="fs-5 fw-bolder font-monospace text-light">Pendataan Inventaris</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-end">
                        <img src={gambar1} className="img-fluid"></img>
                    </div>
                    <div className="col-md-6">
                        <h6>Rencana Kerja dan Anggaran</h6>
                        <span>Rencana Kerja Anggaran (RKA) adalah dokumen yang berisi rencana dan estimasi pengeluaran keuangan yang akan dilakukan oleh Universitas Islam Ogan Komerign Ilir Kayuagung dalam satu tahun anggaran. RKA merupakan dokumen strategis yang menjadi 
                            instrumen utama bagi Universitas Islam Ogan Komering Ilir Kayuagung dalam menjalankan kegiatan administratif, mengalokasikan sumber daya keuangan, serta mengukur pencapaian tujuan-tujuan program kerja akademik maupun pembangunan.
                            RKA berisi: 
                            1. Rencana pendapatan 
                            2. Rencana belanja program dan kegiatan 
                            3. Rencana pembiayaan 
                            4. Program dan kegiatan Universitas
                            5. Penjabaran dari Rencana Kerja dan Rencana Strategis Universitas  
                            6. Anggaran yang diperlukan untuk melaksanakan program dan kegiatan</span>
                    </div>
                    <div className="col-md-12 text-center">
                        <img src={gambar2} className="img-fluid"></img>
                    </div>
                    <div className="col-md-12">
                        <h6>Beberapa fitur yang akan dimiliki aplikasi sistem inventaris aset digital:</h6>
                        <ol class="list-group list-group-numbered">
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Pencatatan Aset</div>
                                    Aplikasi ini memungkinkan Anda untuk mencatat semua aset yang dimiliki oleh perusahaan, termasuk deskripsi, nomor seri, tanggal pembelian, dan atribut lainnya yang relevan. Ini memudahkan Anda dalam melacak dan mengidentifikasi setiap aset secara individu.
                                    </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Pembaruan Status</div>
                                    Anda dapat memperbarui status aset, seperti ketersediaan, lokasi, atau kondisi saat ini. Hal ini memungkinkan Anda untuk memiliki visibilitas yang akurat mengenai status setiap aset.
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Pelacakan Riwayat</div>
                                    Aplikasi ini mencatat riwayat perubahan aset, seperti pembaruan status, perbaikan, atau pemindahan. Ini membantu Anda melacak pergerakan dan perubahan yang terjadi pada setiap aset dari waktu ke waktu.
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Pencarian dan Filter</div>
                                    Terdapat fitur pencarian dan filter yang memungkinkan Anda untuk mencari aset berdasarkan kriteria tertentu, seperti nama, kategori, atau departemen terkait. Hal ini memudahkan Anda dalam menemukan aset yang Anda butuhkan dengan cepat.
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Pengelompokan Aset</div>
                                    Anda dapat mengelompokkan aset berdasarkan kategori, departemen, atau atribut lainnya. Ini membantu dalam pengorganisasian dan pemantauan aset yang serupa atau terkait.
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Integrasi Barcode atau QRCode</div>
                                    Beberapa aplikasi inventaris aset dapat diintegrasikan dengan teknologi barcode atau QRCode untuk memudahkan dalam pencatatan dan pelacakan aset. Anda dapat dengan mudah memindai kode barcode atau QRCode untuk mengidentifikasi aset secara akurat.
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-start">
                                <div class="ms-2 me-auto">
                                    <div class="fw-bold">Laporan dan Analitik</div>
                                    Aplikasi ini sering dilengkapi dengan fitur laporan dan analitik yang membantu Anda menganalisis penggunaan aset, biaya pemeliharaan, dan tren lainnya. Laporan ini memberikan wawasan yang berharga untuk pengambilan keputusan yang lebih baik terkait aset.
                                </div>
                            </li>
                        </ol>
                    </div>
                    
                </div>

            </div>
        </>
    )
}
export default Dash;